(function () {
    'use strict';
    if (window.Code118AddonAttribution) return;

    const families = {
        'tracker-card': 'tracker', 'modular-backplate': 'backplate',
        'modular-backplate-cash-clip': 'backplate', 'leather-case': 'leather',
        'bi-fold-leather-case': 'leather', 'tool-card': 'multi',
        'airtag-strap': 'airtag', 'stash-tray': 'stash', 'mag-pouch': 'mag',
        'silicone-cash-strap': 'cash_strap'
    };
    const models = { 'stealth-wallet': 'classic', 'code-118-wallet-magsafe': 'magsafe' };
    const ownerSelector = ['product', 'productV2', 'productV3'].map(prefix => 'input.' + prefix + 'UpsellItemContainerContentLabelInput').join(',');
    const itemSelector = '.productUpsellItem, .productV2UpsellItem, .productV3UpsellItem';
    const productSelector = '.productJSON, .productV2JSON, .productV3JSON';
    const variants = new Map();
    const selections = new Map();
    const programmaticActivations = new WeakSet();
    const sources = new Set(['buy_box', 'modular_section', 'tracker_section']);
    const storageKey = 'code118:addon-attribution:transfer:' + String(window.Shopify?.theme?.id || 'unknown');
    const expiry = 30 * 60 * 1000;
    let catalogReady = false;
    let transfer = null;

    function parse(value) { try { return JSON.parse(value); } catch (_) { return null; } }
    function id(value) { return String(value ?? '').split('/').pop(); }
    function list(value) { return Array.isArray(value) ? value : value?.nodes || []; }
    function register(product) {
        if (!product || (!families[product.handle] && !models[product.handle])) return;
        list(product.variants).forEach(variant => {
            if (variant?.id) variants.set(id(variant.id), { handle: product.handle, family: families[product.handle], model: models[product.handle] });
        });
    }
    function loadCatalog() {
        const data = parse(document.getElementById('code118-addon-attribution-catalog')?.textContent);
        const products = list(data?.products || data);
        if (!products.length) return;
        products.forEach(register);
        catalogReady = variants.size > 0;
    }
    function pageHandle() {
        const mount = document.getElementById('trip-buybox');
        if (models[mount?.dataset.handle]) return mount.dataset.handle;
        for (const node of document.querySelectorAll(productSelector)) {
            const product = parse(node.textContent);
            if (models[product?.handle]) return product.handle;
        }
        return '';
    }
    function familyForOwner(owner) { return variants.get(id(owner?.value))?.family || families[owner?.closest(itemSelector)?.dataset.p5eHandle] || ''; }
    function ownerFor(family, scope = document) {
        return [...scope.querySelectorAll(ownerSelector)].find(owner => familyForOwner(owner) === family) || null;
    }
    function isWalletSelection() { return Boolean(models[pageHandle()]); }
    function locationSource(target) {
        if (target.closest('#cw-inline-accessory-explorer')) return 'buy_box';
        if (target.closest('#cw-accessory-explorer')) return 'modular_section';
        if (target.closest('[data-p5e-tracker-features]')) return 'tracker_section';
        return 'buy_box';
    }
    function remember(family, source, selected) {
        if (!family || !sources.has(source)) return;
        if (selected) selections.set(family, source);
        else selections.delete(family);
        if (transfer?.addons) transfer.addons = transfer.addons.filter(addon => addon.family !== family);
    }
    function selectionChange(event) {
        if (!catalogReady || event.isTrusted !== true || !isWalletSelection()) return;
        const target = event.target;
        if (!target?.matches || target.disabled || programmaticActivations.has(target)) return;
        const source = locationSource(target);
        if (target.matches('[data-p5e-tracker-choice]')) {
            remember('tracker', source, target.checked);
            return;
        }
        const explorer = target.closest('#cw-accessory-explorer, #cw-inline-accessory-explorer');
        const control = explorer && target.closest('[data-cw-control]');
        if (control && target.matches('[data-cw-check], [data-cw-style], [data-cw-finish], #trip-tracker-add, #cw-inline-tracker-add')) {
            remember(control.dataset.cwControl, source, target.type === 'checkbox' ? target.checked : true);
            return;
        }
        const item = target.closest(itemSelector);
        const owner = item?.querySelector(ownerSelector);
        if (!owner || owner.disabled) return;
        if (target === owner) remember(familyForOwner(owner), source, owner.checked);
        else if (target.matches('select, input[type="radio"]')) remember(familyForOwner(owner), source, true);
    }
    function saveTransfer(target) {
        const link = target.closest('.productV3Links a[data-p5e-wallet-variants]');
        if (!link || !link.closest('[data-p5e-kit-section]')) return;
        const url = new URL(link.getAttribute('href'), location.href);
        const destination = url.pathname.split('/').filter(Boolean).pop();
        if (url.origin !== location.origin || !models[destination] || destination === pageHandle()) return;
        const addons = [];
        document.querySelectorAll(ownerSelector).forEach(owner => {
            const family = familyForOwner(owner);
            const source = sourceFor(family, owner.value, owner.closest('[data-p5e-kit-section]'));
            if (owner.checked && !owner.disabled && sources.has(source)) addons.push({ family, source, variant: id(owner.value) });
        });
        try { sessionStorage.setItem(storageKey, JSON.stringify({ target: destination, created: Date.now(), addons })); } catch (_) { /* Storage is optional. */ }
    }
    function selectionClick(event) {
        const target = event.target;
        if (!target?.closest) return;
        const control = target.matches('input, select') ? target : target.closest('label')?.control;
        if (control) {
            if (event.isTrusted !== true) {
                // .click() can generate a trusted change; its untrusted activation is the discriminator.
                programmaticActivations.add(control);
                queueMicrotask(() => programmaticActivations.delete(control));
            } else programmaticActivations.delete(control);
        }
        if (!catalogReady || event.isTrusted !== true || !isWalletSelection()) return;
        saveTransfer(target);
        const button = target.closest('[data-p5e-select]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        const family = button.dataset.p5eSelect;
        const owner = ownerFor(family, button.closest('[data-p5e-kit-section]') || document);
        if (!owner || owner.disabled) return;
        remember(family, 'buy_box', !owner.checked);
    }
    function readTransfer() {
        try {
            const saved = parse(sessionStorage.getItem(storageKey));
            sessionStorage.removeItem(storageKey);
            if (saved?.target !== pageHandle() || !Array.isArray(saved.addons)) return;
            const age = Date.now() - Number(saved.created);
            if (age < 0 || age >= expiry) return;
            transfer = { addons: saved.addons.filter(addon => sources.has(addon.source) && variants.get(id(addon.variant))?.family === addon.family) };
        } catch (_) { /* Browser storage restrictions must not affect checkout. */ }
    }
    function sourceFor(family, variantId, section) {
        if (selections.has(family)) return selections.get(family);
        const restored = transfer?.addons.find(addon => addon.family === family && addon.variant === id(variantId));
        if (!restored || !section) return 'unknown';
        const owner = ownerFor(family, section);
        return owner?.checked && !owner.disabled && id(owner.value) === id(variantId) ? restored.source : 'unknown';
    }
    function cartModel(cart) {
        const present = new Set();
        for (const item of cart?.items || []) {
            if (item.quantity === 0) continue;
            const model = variants.get(id(item.variant_id || item.id))?.model || models[item.handle];
            if (model) present.add(model);
        }
        return present.size === 1 ? [...present][0] : 'unknown';
    }
    function decorate(formData, context = {}) {
        if (!catalogReady || !Array.isArray(formData?.items)) return formData;
        const product = context.product;
        register(product);
        const walletModel = models[product?.handle];
        const primaryFamily = families[product?.handle];
        const cartPlacement = context.placement === 'cart_upsell';
        if (!cartPlacement && !walletModel && !primaryFamily) return formData;
        const model = cartPlacement ? cartModel(context.cart) : walletModel || 'unknown';
        let changed = false;
        const items = formData.items.map(item => {
            const variant = variants.get(id(item.id));
            if (!variant?.family || (!cartPlacement && !walletModel && variant.handle !== product.handle)) return item;
            const source = cartPlacement ? 'cart_upsell' : primaryFamily ? 'addon_pdp' : sourceFor(variant.family, item.id, context.section);
            changed = true;
            return { ...item, properties: { ...(item.properties || {}), _c118_addon_source: source, _c118_wallet_model: model, _c118_attribution_version: '1' } };
        });
        return changed ? { ...formData, items } : formData;
    }

    try { loadCatalog(); readTransfer(); } catch (_) { catalogReady = false; }
    document.addEventListener('change', event => { try { selectionChange(event); } catch (_) { /* Attribution must never interrupt selection. */ } }, true);
    document.addEventListener('click', event => { try { selectionClick(event); } catch (_) { /* Attribution must never interrupt navigation. */ } }, true);
    window.Code118AddonAttribution = { version: '1', decorate };
}());
